import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"

const PaddedTopSection = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(6),
  [theme.breakpoints.only("xs")]: {
    paddingInline: theme.spacing(2),
  },
  paddingBlock: theme.spacing(3),
}))

export const BorderedPaddedTopSection = styled(PaddedTopSection)(
  ({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.colors.gray200}`,
  })
)

export default PaddedTopSection
